import {State} from './reducer'

export const initialState: Omit<State, 'account'> = {
  showPammManagerUnapprovedPopup: false
}
